import { AppSource } from "@nstep-common/core";
import { LogLevel } from "projects/common/core/services/log/models/log.level";

export class LogEntry {
	entryDate: Date = new Date();
	message: string = "";
	level: LogLevel = LogLevel.Debug;
	extraInfo: any[] = [];
	logWithDate: boolean = true;
	source!: AppSource;


	constructor(data: Partial<LogEntry> | null = null) {
		if (data) {
			Object.assign(this, data);
		}
	}

	buildLogString(): string {
		if (!this.message?.trim()) {
			return "";
		}

		let ret: string = "";

		if (this.logWithDate) {
			ret = new Date() + " - ";
		}

		ret += "Type: " + LogLevel[this.level];
		ret += " - Message: " + this.message;

		if (this.extraInfo.length) {
			ret += " - Extra Info: " + this.formatParams(this.extraInfo);
		}

		return ret;
	}

	private formatParams(params: any[]): string {
		const meaningfulParams = params.filter(param => param !== undefined && param !== null);
		if (!meaningfulParams.length) {
			return "";
		}

		return meaningfulParams.map(item => {
			if (typeof item !== "object") {
				return String(item);
			}

			try {
				return JSON.stringify(item) ?? String(item);
			}
			catch {
				return "[Unserializable log detail]";
			}
		}).join(",");
	}
}